import { Dialog } from '@mui/material';
import React from 'react';
import AllocateForm from './AllocateForm';

const AllocateResourcesModal = ({
  open,
  toggle,
  getData,
  data,
  allEmployees,
  setSnackBarOpen,
  setSnackbarSeverity,
  setSnackBarMessage,
  projectDetails
}) => {
  return (
    <Dialog
      open={open}
      keepMounted
      maxWidth="md"
      fullWidth
      scroll="paper"
      onClose={toggle}
    >
      <AllocateForm
        toggle={toggle}
        open={open}
        getData={getData}
        data={data}
        projectDetails={projectDetails}
        allEmployees={allEmployees}
        setSnackBarOpen={setSnackBarOpen}
        setSnackbarSeverity={setSnackbarSeverity}
        setSnackBarMessage={setSnackBarMessage}
      />
    </Dialog>
  );
};

export default AllocateResourcesModal;
